import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { getStoredUser } from '../helpers/user-storage.util';

@Component({
  selector: 'app-account-side-nav',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './account-side-nav.component.html',
  styleUrl: './account-side-nav.component.scss',
})
export class AccountSideNavComponent {
  constructor(public router: Router) {}

  get isLocked(): boolean {
    return getStoredUser()?.welcomeEmailPending === true;
  }

  goBack(): void {
    this.router.navigate(['invitations']);
  }

  logout(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['login']);
    // Full reload on logout (matches the original per-page behavior) so no
    // in-memory app state survives into the next session.
    window.location.reload();
  }
}
